export default __webpack_public_path__ + "static/media/6.c177110b.jpg";